// extracted by mini-css-extract-plugin
export default {"Dialog":"AddMetadataPatternRuleDialog-module__Dialog--sVMDB"};